<template>
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
</template>

<script>
import store from "@/store";

export default {
  computed: {
    is_loading() {
      return store.state.is_loading;
    }
  },
  watch: {
    is_loading: function (newVal, oldVal) {
      if (newVal) {
        this.loader = this.$loading.show();
      } else this.loader.hide();
    }
  }
  // mounted() {
  //   console.log(
  //     "process.env.VUE_APP_MATTERS_ARISING_BOARD_ID = ",
  //     process.env.VUE_APP_MATTERS_ARISING_BOARD_ID
  //   );
  //   console.log(
  //     "process.env.VUE_APP_PROCUREMENT_BOARD_ID = ",
  //     process.env.VUE_APP_PROCUREMENT_BOARD_ID
  //   );
  // }
};
</script>
<style>
/* width */
::-webkit-scrollbar {
  width: 18px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #ebeef5;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #dfe4f0;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #2e4051;
}

#nprogress .bar {
  background: #FFBB00 !important;
  height: 5px !important;

  z-index: 1050 !important;
}

#nprogress .peg {
  box-shadow: 0 0 10px #FFBB00, 0 0 5px #FFBB00 !important;
}
</style>
